import { render } from "./AccountMsg.vue?vue&type=template&id=c7eddc3c&scoped=true"
import script from "./AccountMsg.vue?vue&type=script&lang=js"
export * from "./AccountMsg.vue?vue&type=script&lang=js"

import "./AccountMsg.vue?vue&type=style&index=0&id=c7eddc3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7eddc3c"]])

export default __exports__